module.exports = __webpack_public_path__ + "font/empty.9761.svg";